import React from "react";
import { BsLayoutSidebar } from "react-icons/bs";
import { SearchIcon } from "../../Icons";
import NavigationBar from "../common/NavigationBar";

export default function ProjectHeader({
  setIsDrawerOpen,
  setSearchQuery,
  searchQuery,
}) {
  return (
    <header className={`px-5 lg:px-10 2xl:px-20 pt-5  pb-5 2xl:pt-[60px]  `}>
      <div className="flex items-center justify-between gap-3 ">
        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsDrawerOpen(true)}
          className="md:hidden flex items-center gap-2 text-white  hover:bg-white/10 rounded-lg transition-colors"
          aria-label="Open menu"
        >
          <BsLayoutSidebar size={24} color="#8E98C7" />
        </button>

        {/* Search Bar */}
        <form className="sm:py-[7px] py-1 px-[14px] bg-black/30 max-w-[442px] w-full shadow-[0_4px_8px_0_rgba(0,_0,_0,_0.05)] flex items-center gap-3 rounded-[8px] flex-1">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="flex-1 w-full bg-transparent border-none outline-none pl-2.5 placeholder:text-[#8E98C7] text-white text-[16px] font-normal"
            placeholder="Search"
            aria-label="Search projects"
          />
          <button
            type="submit"
            className="p-1 hover:bg-white/10 rounded transition-colors"
            aria-label="Search"
          >
            <SearchIcon />
          </button>
        </form>

        {/* Navigation */}
        <NavigationBar />
      </div>
    </header>
  );
}
